import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

import DistributorDashboard from '../pages/modules/distributor';
import UserManagementRetailer from '../pages/modules/distributor/UserManagementRetailer';
import TopUpRequestFromRetailer from '../pages/modules/distributor/TopUpRequestFromRetailer';
import SendTopUpRequest from '../pages/modules/distributor/SendTopUpRequest';
import ReportsLedger from '../pages/modules/distributor/ReportsLedger';
import ReportsCommission from '../pages/modules/distributor/ReportsCommission';
import ReportsTopUpHistory from '../pages/modules/distributor/ReportsTopUpHistory';
import ReportsDistributorTransactions from '../pages/modules/distributor/ReportsDistributorTransactions';
import ReportsRetailerTransactions from '../pages/modules/distributor/ReportsRetailerTransactions';
import ReportsOutstanding from '../pages/modules/distributor/ReportsOutstanding';
import ReportsOutstandingSummary from '../pages/modules/distributor/ReportsOutstandingSummary';
import ReportsSetBalanceLimit from '../pages/modules/distributor/ReportsSetBalanceLimit';
import MyProfile from '../pages/profile/MyProfile';

const DistributorRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="/dashboard" replace />} />
      <Route path="/dashboard" element={<DistributorDashboard />} />
      <Route path="/user-management/retailer" element={<UserManagementRetailer />} />
      <Route path="/top-up-request/from-retailer" element={<TopUpRequestFromRetailer />} />
      <Route path="/top-up-request/send" element={<SendTopUpRequest />} />
      <Route path="/reports/ledger" element={<ReportsLedger />} />
      <Route path="/reports/commission" element={<ReportsCommission />} />
      <Route path="/reports/top-up-history" element={<ReportsTopUpHistory />} />
      <Route path="/reports/distributor-transactions" element={<ReportsDistributorTransactions />} />
      <Route path="/reports/retailer-transactions" element={<ReportsRetailerTransactions />} />
      <Route path="/reports/outstanding" element={<ReportsOutstanding />} />
      <Route path="/reports/outstanding-summary" element={<ReportsOutstandingSummary />} />
      <Route path="/reports/set-balance-limit" element={<ReportsSetBalanceLimit />} />
      <Route path="/profile" element={<MyProfile />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

export default DistributorRoutes;